import {
  FETCH_CARDS_START,
  FETCH_CARDS_SUCCESS,
  FETCH_CARDS_ERROR,
  BIND_CARD_START,
  BIND_CARD_SUCCESS,
  BIND_CARD_GAME_SUCCESS,
  BIND_CARD_ERROR,
  FETCH_CARDS_BONUSES_START,
  FETCH_CARDS_BONUSES_SUCCESS,
  FETCH_CARDS_BONUSES_ERROR,
  CHANGE_CARD_DESIGN_START,
  CHANGE_CARD_DESIGN_SUCCESS,
  CHANGE_CARD_DESIGN_ERROR
} from './mutation-types'
import { UNKNOWN_CARD_TYPE } from '@/constants'

export default {
  [FETCH_CARDS_START] (state) {
    state.loading = true
  },

  [FETCH_CARDS_SUCCESS] (state, { cards, meta }) {
    state.cards = cards.map(card => ({ ...card, cardType: card.cardType || UNKNOWN_CARD_TYPE }))
    state.meta = meta
    state.loading = false
  },

  [FETCH_CARDS_ERROR] (state, errors) {
    state.errors = errors
    state.loading = false
  },

  [BIND_CARD_START] (state) {
    state.loading = true
  },

  [BIND_CARD_SUCCESS] (state) {
    state.loading = false
  },

  [BIND_CARD_GAME_SUCCESS] (state, { cardId, currentGame }) {
    state.cards = state.cards.map(card => card.cardId === cardId ? { ...card, currentGame } : card)
    state.loading = false
  },

  [BIND_CARD_ERROR] (state, errors) {
    state.errors = errors
    state.loading = false
  },

  [FETCH_CARDS_BONUSES_START] (state) {
    state.loading = true
  },

  [FETCH_CARDS_BONUSES_SUCCESS] (state, cardsBonuses) {
    state.bonuses = cardsBonuses
    state.loading = false
  },

  [FETCH_CARDS_BONUSES_ERROR] (state, errors) {
    state.errors = errors
    state.loading = false
  },

  [CHANGE_CARD_DESIGN_START] (state) {
    state.loading = true
  },

  [CHANGE_CARD_DESIGN_SUCCESS] (state, { cardId, currentDesign }) {
    state.cards = state.cards.map(card => card.cardId === cardId ? { ...card, currentDesign } : card)
    state.loading = false
  },

  [CHANGE_CARD_DESIGN_ERROR] (state, errors) {
    state.errors = errors
    state.loading = false
  }
}
